import React, { useContext, Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../auth/AuthContext';

const ROLE_COLORS = {
  admin: 'bg-purple-100 text-purple-800',
  operator: 'bg-blue-100 text-blue-800',
  viewer: 'bg-gray-100 text-gray-800',
};

export default function HeaderUserMenu() {
  const { t } = useTranslation(['ui']);
  const { username, role, logout } = useContext(AuthContext);
  const displayName = username || 'User';
  const initial = displayName.charAt(0).toUpperCase();
  const roleColorClass = ROLE_COLORS[role] || 'bg-gray-100 text-gray-800';

  return (
    <Menu as="div" className="relative">
      <Menu.Button
        className="flex items-center gap-2 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        aria-label={displayName}
      >
        <span className="h-8 w-8 rounded-full bg-primary-700 text-white flex items-center justify-center font-medium">
          {initial}
        </span>
        <span className="hidden md:flex flex-col items-start leading-tight">
          <span className="text-sm font-medium text-gray-900">{displayName}</span>
          {role && (
            <span className={`text-[10px] uppercase tracking-wide px-1.5 rounded ${roleColorClass}`}>
              {role}
            </span>
          )}
        </span>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-xs text-gray-500">{t('ui:header.signedInAs')}</p>
            <p className="text-sm font-medium text-gray-900 truncate">{displayName}</p>
            {role && (
              <span className={`mt-1 inline-block text-[10px] uppercase tracking-wide px-2 py-0.5 rounded ${roleColorClass}`}>
                {role}
              </span>
            )}
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  type="button"
                  onClick={logout}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  {t('ui:header.userMenu.signOut')}
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
